import React, { PropsWithChildren } from 'react'
import { Link as MuiLink, LinkProps } from '@mui/material'

export type { LinkProps }

export const Link: React.FC<PropsWithChildren & LinkProps> = ({
  children,
  ...props
}) => (
  <MuiLink underline='hover' {...props}>
    {children}
  </MuiLink>
)
